import React from 'react';
import { motion } from 'framer-motion';
import { scrollToPurchase } from '../utils/scrollToPurchase';
export function HeroSection() {
  return <section className="relative pt-6 md:pt-20 pb-2 md:pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-94">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-95">
        <div className="inline-block mb-2 md:mb-4 px-3 md:px-4 py-1 md:py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-400 font-semibold text-[11px] md:text-sm tracking-wider uppercase" data-id="element-96">
          💈 PARA BARBEROS QUE TRABAJAN TODAS LAS SEMANAS
        </div>

        <h1 className="text-3xl md:text-7xl font-heading font-bold text-white mb-2 md:mb-6 leading-[1.05] uppercase" data-id="element-97">
          DE MARTES VACÍO A{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-98">
            SEMANA COMPLETA
          </span>
        </h1>

        <p className="text-sm md:text-2xl text-zinc-400 mb-3 md:mb-10 max-w-3xl mx-auto font-medium leading-snug" data-id="element-99">
          Dejá de esperar que el martes se llene solo y de matarte el sábado
          para compensar.
        </p>

        <motion.div className="relative rounded-xl md:rounded-2xl overflow-hidden border border-zinc-800 shadow-2xl shadow-amber-500/10 cursor-pointer group" whileHover={{
        scale: 1.01
      }} transition={{
        duration: 0.3
      }} onClick={scrollToPurchase} data-id="element-100">
          <div className="absolute inset-0 bg-zinc-950/40 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-101" />
          <img src="https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=1200&q=80" alt="Barber tools and shop" className="w-full h-[130px] md:h-[500px] object-cover object-center" data-id="element-102" />
          <div className="absolute inset-0 flex items-center justify-center z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-103">
            <div className="bg-amber-500 text-zinc-950 px-6 py-3 rounded-full font-bold uppercase tracking-wider shadow-xl" data-id="element-104">
              Ver el plan
            </div>
          </div>
        </motion.div>

        <p className="text-xs md:text-sm text-white/90 mt-2 md:mt-4 max-w-md mx-auto leading-snug font-semibold" data-id="element-105">
          Más equilibrio en la semana, más ingreso por cliente y menos desgaste
          físico sin tener que subir fuerte los precios ni traer más gente.
        </p>
      </motion.div>
    </section>;
}